import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class FireflyKind extends Cloneable {
    static NONE = new FireflyKind(0, "NONE");
    static WAVE = new FireflyKind(1, "WAVE");
    static BOMB = new FireflyKind(2, "BOMB");
    static FTUE = new FireflyKind(3, "FTUE");
    static ENERGY = new FireflyKind(4, "ENERGY");
    static MANA = new FireflyKind(5, "MANA");
    static CHEST = new FireflyKind(6, "CHEST");
    static LOVE = new FireflyKind(7, "LOVE");
    static FLOWER = new FireflyKind(8, "FLOWER");
    static AD = new FireflyKind(9, "AD");

    static _values = [
        this.AD,
        this.WAVE,
        this.ENERGY,
        this.MANA,
        this.CHEST,
        this.LOVE,
        this.FLOWER
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, FireflyKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof FireflyKind) {
            return FireflyKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return FireflyKind.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof FireflyKind) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new FireflyKind());
        } else if (target instanceof FireflyKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(FireflyKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});